import { fileSave } from "browser-fs-access";
import JSZip from "jszip";

import { useScaffolder } from "../scaffolding/useScaffolder";
import { useSchematicBuilderContext } from "../SchematicBuilderContext";

let latestZipFileHandle: FileSystemFileHandle | null = null;

export function ScaffoldToZip() {
  const { getRootSchematic, name } = useSchematicBuilderContext();
  const scaffold = useScaffolder();

  return (
    <button
      className="builder-input builder-action builder-scaffold-zip"
      type="submit"
      onClick={async (evt) => {
        evt.preventDefault();
        try {
          const schematic = getRootSchematic();
          const files = scaffold();
          const zip = new JSZip();
          for (const { path, content, base64, binary, executable } of files) {
            zip.file(path, content, {
              base64,
              binary,
              unixPermissions: executable ? "755" : undefined,
            });
          }
          latestZipFileHandle = await fileSave(
            zip.generateAsync({ platform: "UNIX", type: "blob" }),
            {
              fileName: `${schematic.name}.zip`,
              extensions: [".zip"],
              mimeTypes: ["application/zip"],
              description: "Form scaffolding",
              id: name,
            },
            latestZipFileHandle,
          );
        } catch (err) {
          alert(err);
        }
      }}
    >
      Scaffold 🏗️
    </button>
  );
}
